import type { ReactNode } from 'react';
import { ScripsWordmark } from '@/components/atoms/scrips-wordmark';

/** The brand line, title and intro of every sign-in and recovery card (mirror of the Practitioner app's
 *  `AuthBrandHeading`, consistency pass 15 Oct): the Scrips wordmark in the rail's wordmark colour with the product
 *  name beside it in the meta role, then the title in the title role (24/32/600) and the intro in the body role. */
export function AuthBrandHeading({
  title,
  subtitle,
  product = 'Practice',
}: {
  title: ReactNode;
  subtitle?: ReactNode;
  product?: string;
}) {
  return (
    <>
      <p className="m-0 flex items-center gap-2 text-xs text-text-secondary">
        <ScripsWordmark height={20} color="var(--rail-wordmark)" />
        {product}
      </p>
      <h1 className="m-0 text-lg font-semibold text-text-primary">{title}</h1>
      {subtitle && <p className="m-0 text-sm text-text-secondary">{subtitle}</p>}
    </>
  );
}
